const ROUTING_KEY_COOKIE = "sd-routing-key";

/**
 * Communal sandboxes share a host (e.g. prcom2) but route requests per-sandbox
 * using a key stored in the `sd-routing-key` cookie. Returns that key when
 * present so individual sandboxes can be told apart.
 */
export function getRoutingKeyFromCookie(): string | undefined {
  if (typeof document === "undefined") return undefined;

  for (const entry of document.cookie.split(";")) {
    const [rawName, ...rawValue] = entry.split("=");
    if (rawName?.trim() !== ROUTING_KEY_COOKIE) continue;
    return rawValue.join("=").trim() || undefined;
  }

  return undefined;
}
